import StreamForm from "../../../components/data_products/streams/StreamForm";
import {useHistory, useParams} from "react-router-dom";
import {useDifactoBucket} from "../../../components/utils";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import { useGetStreamQuery, useUpdateStreamMutation } from "../../../api/streamApiSlice";
import {useControlledTabs} from "../../../components/Tabs";

function EditStream(props) {
  const history = useHistory();
  const { streamId } = useParams();
  const { data: stream, isSuccess } = useGetStreamQuery(streamId)
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [tabProps,] = useControlledTabs("stream", props)
  const bucket = useDifactoBucket();

  const goToStream = () => history.push({
    pathname: `/streams/${streamId}`,
    state: {activeTab: tabProps.active}
  })

  const [updateStream] = useUpdateStreamMutation()
  const submitProps = {
    handleSubmit: (data) => {
      updateStream({...data, key: streamId}).unwrap()
        .then(goToStream)
        .catch(error => {})
    },
    errors: {}
  }

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title
        main={t("menu.streams")}
        sub={stream.name}
        group={false}
        onBack={goToStream}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToStream} />
      </Title>
      <StreamForm
        stream={stream}
        {...submitProps}
        unbindBucket={true}
        setSubmitButtonProps={setSubmitButtonProps}
        bucket={bucket}
        disabled={(propName)=>{return propName === "data_type"}}
        tabProps={tabProps}/>
    </>
  )
}

export default EditStream
